import { render, staticRenderFns } from "./cDatatableAssigPermission.vue?vue&type=template&id=30e66212&scoped=true"
import script from "./cDatatableAssigPermission.vue?vue&type=script&lang=js"
export * from "./cDatatableAssigPermission.vue?vue&type=script&lang=js"
import style0 from "./cDatatableAssigPermission.vue?vue&type=style&index=0&id=30e66212&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30e66212",
  null
  
)

export default component.exports